/**
 * en-GB messages added by Phase 4 task M7 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const m7EnGB = {
    'companion.p4.your_data.title': 'Your data',
    'companion.p4.your_data.entry': 'Your data and privacy',
    'companion.p4.your_data.intro': 'See how {tenant} looks after your personal information, and ask to see, correct or delete it.',
    'companion.p4.your_data.intro_plain': 'See how your organisation looks after your personal information, and ask to see, correct or delete it.',
    'companion.p4.your_data.open': 'Open the privacy page',
    'companion.p4.your_data.open_failed': 'The privacy page could not be opened. Please try again.',
    'companion.p4.your_data.unavailable': 'Your organisation has not set up a privacy page yet. Please ask your administrator.',
    'companion.p4.your_data.kinds_title': 'What you can ask for',
    'companion.p4.your_data.kind.access': 'A copy of the information we hold about you',
    'companion.p4.your_data.kind.rectification': 'Correct information that is wrong',
    'companion.p4.your_data.kind.erasure': 'Delete the information we hold about you',
    'companion.p4.your_data.kind.stop_marketing': 'Stop marketing messages',
    'companion.p4.your_data.note': 'We will check it is you before we act on a request. The privacy page opens in your browser.',
    'companion.p4.wallet.button': 'Add to Google Wallet',
    'companion.p4.wallet.help': 'Keep your pass on your phone.',
    'companion.p4.wallet.open_failed': 'Google Wallet could not be opened. Please try again.',
    'companion.p4.wallet.preview': 'Google Wallet is not connected for your organisation yet, so this is a test link only.',
    'companion.p4.read_only': "Your organisation's account is on hold, so changes are switched off for now. You can still use I'm safe, the panic button and lone worker check-ins. Please contact your administrator.",
};
//# sourceMappingURL=m7.js.map